<template>
  <div class="containerWrapper planningContainerWrapper">
    <div class="container details">
      <div class="row">
        <div class="col-md-12">
          <Dialog :header="eventHeader" :visible.sync="display">
              <label for="eventText">Rubrik</label><br/>
              <!--InputText type="text" name="eventText" v-model="newEventText" />-->
              <AutoComplete v-model="newEventText" :dropdown="true" :suggestions="filteredEvents" @complete="searchEvents($event)" />
              <br/><br/>
              <label>Tidval</label><br/>
              <RadioButton id="timeChooseOne" name="timeChoose" @change="changedTime('1')" value="1" v-model="timeChoose" />
              <label for="timeChooseOne">FM</label>&nbsp;
              <RadioButton id="timeChooseTwo" name="timeChoose" @change="changedTime('2')" value="2" v-model="timeChoose" />
              <label for="colorTwo">Heldag</label>&nbsp;
              <RadioButton id="timeChooseThree" name="timeChoose" @change="changedTime('3')" value="3" v-model="timeChoose" />
              <label for="colorTwo">EM</label>&nbsp;
              <br/><br/>
              <label>Starttid</label><br/>
              <Calendar v-model="newEventStartDate" :selectOtherMonths="true" :locale="sv" dateFormat="yy-mm-dd" :showTime="true"/><br/><br/>
              <label>Sluttid</label><br/>
              <Calendar v-model="newEventEndDate" :selectOtherMonths="true" :locale="sv" dateFormat="yy-mm-dd" :showTime="true"/><br/><br/>
              <Checkbox v-model="showForExternal" :binary="true" inputId="showForExternal" /> <label for="showForExternal" > Visa för externa</label><br/><br/>
              <label>Färg</label><br/>
              <RadioButton id="colorOne" name="color" value="#1a6299" v-model="newEventColor" />
              <label for="colorOne">Blå</label>&nbsp;
              <RadioButton id="colorTwo" name="color" value="#e91224" v-model="newEventColor" />
              <label for="colorTwo">Röd</label>&nbsp;
              <RadioButton id="colorThree" name="color" value="#000000" v-model="newEventColor" />
              <label for="colorThree">Svart</label>
              <template #footer>
                <Button :label="dialogConfirmBtnText" @click="addEvent" icon="pi pi-check" />
                <Button v-if="dialogConfirmBtnText != 'Lägg till'" label="Kopiera" @click="copyEvent" icon="pi pi-file"/>
                <Button v-if="dialogConfirmBtnText == 'Lägg till'" label="Avbryt" @click="cancelAddEvent" icon="pi pi-times" class="p-button-secondary"/>
                <Button v-else label="Ta bort" @click="deleteInfoEvent" icon="pi pi-times" class="p-button-danger"/>
              </template>
          </Dialog>
           <Dialog header="Gå till datum" :visible.sync="displayGoToDate">
              <Calendar v-model="chosenDate" :selectOtherMonths="true" :locale="sv" dateFormat="yy-mm-dd" :showTime="false"/>
           </Dialog>
          <div class="planningWrapper">
            <PlanningCalendar :events="EVENTS" :refetch="refetch" :options="options" :resources="ORDERS_NOT_SET_AS_RESOURCES" :chosenDate="chosenDate" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import PlanningCalendar from './PlanningCalendar'
import { bus } from '@/main'
import AutoComplete from 'primevue/autocomplete'
import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
import interactionPlugin from '@fullcalendar/interaction'
import svLocale from '@fullcalendar/core/locales/sv'
import moment from 'moment'
import { mapGetters } from 'vuex'
import Dialog from 'primevue/dialog'
import Toast from 'primevue/toast'
import Tooltip from 'primevue/tooltip'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Calendar from 'primevue/calendar'
import RadioButton from 'primevue/radiobutton'
import Checkbox from 'primevue/checkbox'
export default {
  name: 'Planning',
  components: {
    PlanningCalendar,
    Dialog,
    Toast,
    InputText,
    Button,
    Calendar,
    RadioButton,
    Checkbox,
    AutoComplete
  },
  directives: {
    tooltip: Tooltip
  },
  data () {
    return {
      chosenDate: null,
      displayGoToDate: false,
      eventHeader: 'Lägg till händelse',
      refetch: false,
      sv: {
        firstDayOfWeek: 1,
        dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
        dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
        dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
        monthNames: [ 'Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December' ],
        monthNamesShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec' ],
        today: 'Idag',
        clear: 'Rensa',
        dateFormat: 'yy-mm-dd',
        weekHeader: 'vk'
      },
      display: false,
      timeChoose: '',
      selectedId: null,
      selectedResource: null,
      newEventStartDate: null,
      newEventEndDate: null,
      newEventColor: null,
      newEventText: '',
      showForExternal: false,
      defaultEvents: [],
      filteredEvents: null,
      dialogConfirmBtnText: 'Lägg till',
      options: {
        height: 'parent',
        editable: true,
        nowIndicator: true,
        locale: svLocale,
        defaultDate: moment().add(-1, 'days').format('YYYY-MM-DD HH:MM'),
        resourceLabelText: 'Lastbilar',
        resourceGroupField: 'groupId',
        resourceOrder: 'sortOrder',
        firstDay: 0,
        plugins: [resourceTimelinePlugin, interactionPlugin],
        droppable: true,
        schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
        defaultView: 'resourceTimelineSevenDay',
        eventOrder: (first, second) => {
          if (first.groupId !== '' || second.groupId !== '') {
            if (first.groupId === second.groupId) {
              return -1
            }
          }
          return first.start < second.start ? -1 : 1
        },
        views: {
          resourceTimelineSevenDay: {
            dateIncrement: { days: 1 },
            duration: { days: 7 },
            type: 'resourceTimeline',
            resourceAreaWidth: '6%',
            slotLabelFormat: [
              { weekday: 'short', month: 'short', day: 'numeric', omitCommas: true },
              { hour: 'numeric' }
            ],
            slotDuration: '04:00',
            minTime: '06:00:01',
            maxTime: '22:00:00'
          }
        },
        resources: (fetchInfo, successCallback, failureCallback) => {
          successCallback([...this.TRUCKS_AS_RESOURCES, ...this.ORDERS_NOT_SET_AS_RESOURCES, {id: 0, groupId: 'Tankbil', title: 'Allmänt', sortOrder: 0}, {id: 99999, groupId: 'Tankbil', title: 'Ej klar', sortOrder: 99999}])
        },
        eventRender: (info) => {
          let hoverInfo = ''
          let order = info.event._def.extendedProps.order
          if (info.event._def.extendedProps.order && info.event._def.extendedProps.order.type === 'feralco') {
            let endCustomer = info.event._def.extendedProps.endCustomer
            hoverInfo = order.data.DecidedLoadingDate
            if (order.data.DecidedLoadingStartTime) {
              hoverInfo = hoverInfo + ' ' + order.data.DecidedLoadingStartTime
            }
            hoverInfo = hoverInfo + ' ' + endCustomer
            if (order.data.InternDeliveryPlaceComments) {
              hoverInfo = hoverInfo + ' ' + order.data.InternDeliveryPlaceComments
            }
            if (order.data.DeliveryPlaceComments) {
              hoverInfo = hoverInfo + ' ' + order.data.DeliveryPlaceComments
            }
            if (order.data.SalesId) {
              let shortSalesId = order.data.SalesId.replace('SO', '')
              hoverInfo = hoverInfo + ' ' + shortSalesId
            }
          } else if (info.event._def.extendedProps.order && info.event._def.extendedProps.order.type === 'feralcoIntern') {
            hoverInfo = moment(order.data.dateDelivery).format('YYYY-MM-DD')
            hoverInfo = hoverInfo + (order.data.DecidedLoadingStartTime === '' ? '' : ' ' + order.data.DecidedLoadingStartTime + '-' + order.data.DecidedLoadingEndTime)
            if (order.data.comment) {
              hoverInfo = hoverInfo + ' ' + order.data.comment
            }
          } else {
            hoverInfo = info.event.title
          }
          info.el.getElementsByClassName('fc-title-wrap')[0].setAttribute('aria-label', hoverInfo)
          info.el.getElementsByClassName('fc-title-wrap')[0].setAttribute('data-balloon-pos', 'down')
          if (info.event.groupId !== '') {
            let style = document.createElement('style')
            let cssClass = '.' + info.event.groupId
            let borderColor = info.event.borderColor
            if (borderColor !== '#ff0000') {
              borderColor = '#007ad9'
            }
            style.type = 'text/css'
            style.innerHTML = '.fc-event-container ' + cssClass + '{border-right: dashed 2px' + borderColor + ' !important; border-left: dashed 2px ' + borderColor + ' !important; border-bottom: dashed 2px ' + borderColor + ' !important; border-top: none !important; margin-top: -3px !important; border-top-right-radius: 0px !important; border-top-left-radius: 0px !important;}'
            style.innerHTML = style.innerHTML + '.fc-event-container ' + cssClass + '~ ' + cssClass + '{ border-top: dashed 2px ' + borderColor + ' !important; border-bottom: none !important; border-right: dashed 2px ' + borderColor + ' !important; border-left: dashed 2px ' + borderColor + ' !important; }'
            document.getElementsByTagName('head')[0].appendChild(style)
          }
        },
        drop: (info) => {
          if (info.newResource !== null) {
            let message = ''
            if (info.event.groupId !== '') {
              message = 'Vill du sätta ' + info.newResource.title + ' på valda ordrar?'
            } else {
              message = 'Vill du sätta ' + info.newResource.title + ' på ordern?'
            }
            let options = {
              okText: 'Fortsätt',
              cancelText: 'Stäng'
            }
            this.$dialog.confirm(message, options)
              .then(dialog => {
                if (info.event.groupId !== '') {
                  let groupId = info.event.groupId
                  for (var i = 0; i < this.ORDERS_AS_EVENTS.length; i++) {
                    if (this.ORDERS_AS_EVENTS[i].groupId === groupId) {
                      this.updateOrderWithTruck(info, this.ORDERS_AS_EVENTS[i].id)
                    }
                  }
                } else {
                  this.updateOrderWithTruck(info, info.event.id)
                }
              })
              .catch(function (e) {
                info.revert()
              })
          }
        },
        eventDrop: (info) => {
          if (info.event.extendedProps.type === 'order') {
            if (info.newResource !== null) {
              let message = ''
              if (info.event.groupId !== '') {
                message = 'Vill du sätta ' + info.newResource.title + ' på valda ordrar?'
              } else {
                message = 'Vill du sätta ' + info.newResource.title + ' på ordern?'
              }
              let options = {
                okText: 'Fortsätt',
                cancelText: 'Stäng'
              }
              this.$dialog.confirm(message, options)
                .then(dialog => {
                  if (info.event.groupId !== '') {
                    let groupId = info.event.groupId
                    for (var i = 0; i < this.ORDERS_AS_EVENTS.length; i++) {
                      if (this.ORDERS_AS_EVENTS[i].groupId === groupId) {
                        this.updateOrderWithTruck(info, this.ORDERS_AS_EVENTS[i].id)
                        this.$store.dispatch('GET_ORDERS_AS_RESOURCES')
                      }
                    }
                  } else {
                    this.updateOrderWithTruck(info, info.event.id)
                  }
                })
                .catch(function (e) {
                  info.revert()
                })
            }
          } else {
            this.selectedId = info.event.id
            this.newEventColor = info.event.backgroundColor
            this.newEventText = info.event.title
            if (info.newResource !== null) {
              this.selectedResource = info.newResource.id
            } else {
              this.selectedResource = info.event._def.resourceIds[0]
            }
            this.newEventStartDate = info.event.start
            this.newEventEndDate = info.event.end
            this.movedInfoEvent()
          }
        },
        eventClick: (info) => {
          info.jsEvent.preventDefault()
          if (info.event.url) {
            window.open(info.event.url)
          } else if (info.event.extendedProps.type === 'info') {
            this.selectedId = info.event.id
            this.newEventText = info.event.title
            this.newEventStartDate = info.event.start
            this.newEventEndDate = info.event.end
            this.dialogConfirmBtnText = 'Uppdatera'
            this.eventHeader = 'Uppdatera händelse'
            this.selectedResource = info.event._def.resourceIds[0]
            this.display = true
            this.timeChoose = ''
            this.newEventColor = info.event.backgroundColor
            this.showForExternal = info.event.extendedProps.showForExternal
          }
        },
        dateClick: (info) => {
          this.newEventText = ''
          this.newEventEndDate = info.date
          this.newEventStartDate = info.date
          this.selectedResource = info.resource.id
          this.display = true
          this.timeChoose = ''
          this.dialogConfirmBtnText = 'Lägg till'
          this.eventHeader = 'Lägg till händelse'
        }
      }
    }
  },
  async mounted () {
    await this.$store.dispatch('GET_TRUCKS')
    await this.$store.dispatch('GET_ORDERS_AS_RESOURCES')
    await this.$store.dispatch('GET_DRIVERS')
    await this.$store.dispatch('GET_FERALCOARTICLES')
    await this.$store.dispatch('GET_CALENDAR_EVENTS')
    await this.$store.dispatch('GET_DATE_RANGED_ORDERS')
    await this.$store.dispatch('GET_DEFAULTEVENTS')
    this.defaultEvents = this.DEFAULT_EVENTS_AS_TITLE
  },
  async created () {
    bus.$on('displayGoToDate', displayGoToDate => {
      this.displayGoToDate = displayGoToDate
    })
  },
  computed: {
    ...mapGetters(['EVENTS', 'DATE_RANGED_ORDERS', 'ORDERS_IN_DATE_RANGE', 'ORDERS_AS_EVENTS', 'ORDERS_NOT_SET_AS_RESOURCES', 'ORDERS_AS_RESOURCES', 'TRUCKS_AS_RESOURCES', 'DEFAULT_EVENTS_AS_TITLE', 'CUSTOMERPLACES'])
  },
  methods: {
    getTrucks () {
      return this.TRUCKS_AS_RESOURCES
    },
    changedTime (chosenTime) {
      let newStartTime = ''
      let newEndTime = ''
      if (chosenTime === '1') {
        newStartTime = moment(this.newEventStartDate).format('YYYY-MM DD 01:00')
        newEndTime = moment(this.newEventStartDate).format('YYYY-MM DD 15:00')
      } else if (chosenTime === '2') {
        newStartTime = moment(this.newEventStartDate).format('YYYY-MM DD 01:00')
        newEndTime = moment(this.newEventStartDate).format('YYYY-MM DD 23:00')
      } else if (chosenTime === '3') {
        newStartTime = moment(this.newEventStartDate).format('YYYY-MM DD 15:10')
        newEndTime = moment(this.newEventStartDate).format('YYYY-MM DD 23:00')
      }

      this.newEventStartDate = new Date(newStartTime)
      this.newEventEndDate = new Date(newEndTime)
    },
    searchEvents (event) {
      setTimeout(() => {
        let results
        if (event.query.length === 0) {
          results = [...this.defaultEvents]
        } else {
          results = this.defaultEvents.filter((defaultEvent) => {
            return defaultEvent.toLowerCase().startsWith(event.query.toLowerCase())
          })
        }
        this.filteredEvents = results
      }, 250)
    },
    getDriverAndTrailerByTruck (truckId) {
      let driverId = null
      let trailerId = null
      for (var i = 0; i < this.DATE_RANGED_ORDERS.length; i++) {
        if (this.DATE_RANGED_ORDERS[i].data.truck !== undefined && this.DATE_RANGED_ORDERS[i].data.truck !== null && this.DATE_RANGED_ORDERS[i].data.truck.toString() === truckId.toString()) {
          if (this.DATE_RANGED_ORDERS[i].data.driver !== undefined && this.DATE_RANGED_ORDERS[i].data.driver !== null) {
            driverId = this.DATE_RANGED_ORDERS[i].data.driver
            if (this.DATE_RANGED_ORDERS[i].data.trailer !== undefined && this.DATE_RANGED_ORDERS[i].data.trailer !== null) {
              trailerId = this.DATE_RANGED_ORDERS[i].data.trailer
            } else {
              trailerId = null
            }
          }
        }
      }
      return [driverId, trailerId]
    },
    updateOrderWithTruck (info, orderId) {
      let driverId = this.getDriverAndTrailerByTruck(info.newResource.id)[0]
      let trailerId = this.getDriverAndTrailerByTruck(info.newResource.id)[1]
      var url = '/api/orders/' + orderId + '/addtruck/'
      this.$http
        .put(url, {
          info: {
            truck: parseInt(info.newResource.id, 10),
            driver: parseInt(driverId, 10),
            trailer: parseInt(trailerId, 10)
          }
        })
        .then(response => {
          this.$toast.add({severity: 'success', summary: 'Order uppdaterad', life: 3000})
        })
        .catch(error => console.log(error))
    },
    async addEvent () {
      if (this.dialogConfirmBtnText === 'Lägg till') {
        this.display = false
        this.$store.dispatch('CREATE_CALENDAR_EVENT', {
          title: this.newEventText,
          start: this.newEventStartDate,
          end: this.newEventEndDate == null ? this.newEventStartDate : this.newEventEndDate,
          color: this.newEventColor == null ? null : this.newEventColor,
          resourceId: this.selectedResource,
          showForExternal: this.showForExternal
        })
      } else {
        this.$store.dispatch('SET_CALENDAR_EVENT', {
          id: this.selectedId,
          title: this.newEventText,
          end: this.newEventEndDate,
          start: this.newEventStartDate,
          color: this.newEventColor == null ? null : this.newEventColor,
          resourceId: this.selectedResource,
          showForExternal: this.showForExternal
        })
        this.display = false
      }
      this.refetch = true
    },
    async copyEvent () {
      this.display = false
      this.$store.dispatch('CREATE_CALENDAR_EVENT', {
        title: this.newEventText,
        start: this.newEventStartDate,
        end: this.newEventEndDate == null ? this.newEventStartDate : this.newEventEndDate,
        color: this.newEventColor == null ? null : this.newEventColor,
        resourceId: this.selectedResource,
        showForExternal: this.showForExternal
      })
    },
    cancelAddEvent () {
      this.display = false
    },
    async movedInfoEvent () {
      this.$store.dispatch('SET_CALENDAR_EVENT', {
        id: this.selectedId,
        title: this.newEventText,
        start: this.newEventStartDate,
        color: this.newEventColor == null ? null : this.newEventColor,
        end: this.newEventEndDate == null ? this.newEventStartDate : this.newEventEndDate,
        resourceId: this.selectedResource,
        showForExternal: this.showForExternal
      })
    },
    async deleteInfoEvent () {
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm('Är du säker?', options)
        .then(dialog => {
          this.$store.dispatch('DELETE_CALENDAR_EVENT', this.selectedId)
          this.display = false
        })
        .catch(function (e) {})
      this.refetch = true
    }
  }
}
</script>
<style>
.fc {
  direction: ltr;
  text-align: left;
}

.fc-rtl {
  text-align: right;
}

body .fc {
  /* extra precedence to overcome jqui */
  font-size: 1em;
}

/* Colors
--------------------------------------------------------------------------------------------------*/
.fc-highlight {
  /* when user is selecting cells */
  background: #bce8f1;
  opacity: 0.3;
}

.fc-bgevent {
  /* default look for background events */
  background: #8fdf82;
  opacity: 0.3;
}

.fc-nonbusiness {
  /* default look for non-business-hours areas */
  /* will inherit .fc-bgevent's styles */
  background: #d7d7d7;
}

/* Popover
--------------------------------------------------------------------------------------------------*/
.fc-popover {
  position: absolute;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.fc-popover .fc-header {
  /* TODO: be more consistent with fc-head/fc-body */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 2px 4px;
}

.fc-rtl .fc-popover .fc-header {
  flex-direction: row-reverse;
}

.fc-popover .fc-header .fc-title {
  margin: 0 2px;
}

.fc-popover .fc-header .fc-close {
  cursor: pointer;
  opacity: 0.65;
  font-size: 1.1em;
}

/* Misc Reusable Components
--------------------------------------------------------------------------------------------------*/
.fc-divider {
  border-style: solid;
  border-width: 1px;
}

hr.fc-divider {
  height: 0;
  margin: 0;
  padding: 0 0 2px;
  /* height is unreliable across browsers, so use padding */
  border-width: 1px 0;
}

.fc-bg,
.fc-bgevent-skeleton,
.fc-highlight-skeleton,
.fc-mirror-skeleton {
  /* these element should always cling to top-left/right corners */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.fc-bg {
  bottom: 0;
  /* strech bg to bottom edge */
}

.fc-bg table {
  height: 100%;
  /* strech bg to bottom edge */
}

/* Tables
--------------------------------------------------------------------------------------------------*/
.fc table {
  width: 100%;
  box-sizing: border-box;
  /* fix scrollbar issue in firefox */
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 1em;
  /* normalize cross-browser */
}

.fc th {
  text-align: center;
}

.fc th,
.fc td {
  border-style: solid;
  border-width: 1px;
  padding: 0;
  vertical-align: top;
}

.fc td.fc-today {
  border-style: double;
  /* overcome neighboring borders */
}

/* Internal Nav Links
--------------------------------------------------------------------------------------------------*/
a[data-goto] {
  cursor: pointer;
}

a[data-goto]:hover {
  text-decoration: underline;
}

/* Fake Table Rows
--------------------------------------------------------------------------------------------------*/
.fc .fc-row {
  /* extra precedence to overcome themes forcing a 1px border */
  /* no visible border by default. but make available if need be (scrollbar width compensation) */
  border-style: solid;
  border-width: 0;
}

.fc-row table {
  /* don't put left/right border on anything within a fake row.
     the outer tbody will worry about this */
  border-left: 0 hidden transparent;
  border-right: 0 hidden transparent;
  /* no bottom borders on rows */
  border-bottom: 0 hidden transparent;
}

.fc-row:first-child table {
  border-top: 0 hidden transparent;
  /* no top border on first row */
}

/* Day Row (used within the header and the DayGrid)
--------------------------------------------------------------------------------------------------*/
.fc-row {
  position: relative;
}

.fc-row .fc-bg {
  z-index: 1;
}

/* highlighting cells & background event skeleton */
.fc-row .fc-bgevent-skeleton,
.fc-row .fc-highlight-skeleton {
  bottom: 0;
  /* stretch skeleton to bottom of row */
}

.fc-row .fc-bgevent-skeleton table,
.fc-row .fc-highlight-skeleton table {
  height: 100%;
  /* stretch skeleton to bottom of row */
}

.fc-row .fc-highlight-skeleton td,
.fc-row .fc-bgevent-skeleton td {
  border-color: transparent;
}

.fc-row .fc-bgevent-skeleton {
  z-index: 2;
}

.fc-row .fc-highlight-skeleton {
  z-index: 3;
}

/*
row content (which contains day/week numbers and events) as well as "mirror" (which contains
temporary rendered events).
*/
.fc-row .fc-content-skeleton {
  position: relative;
  z-index: 4;
  padding-bottom: 2px;
  /* matches the space above the events */
}

.fc-row .fc-mirror-skeleton {
  z-index: 5;
}

.fc .fc-row .fc-content-skeleton table,
.fc .fc-row .fc-content-skeleton td,
.fc .fc-row .fc-mirror-skeleton td {
  /* see-through to the background below */
  /* extra precedence to prevent theme-provided backgrounds */
  background: none;
  /* in case <td>s are globally styled */
  border-color: transparent;
}

.fc-row .fc-content-skeleton td,
.fc-row .fc-mirror-skeleton td {
  /* don't put a border between events and/or the day number */
  border-bottom: 0;
}

.fc-row .fc-content-skeleton tbody td,
.fc-row .fc-mirror-skeleton tbody td {
  /* don't put a border between event cells */
  border-top: 0;
}

/* Scrolling Container
--------------------------------------------------------------------------------------------------*/
.fc-scroller {
  -webkit-overflow-scrolling: touch;
}

/* TODO: move to timegrid/daygrid */
.fc-scroller > .fc-day-grid,
.fc-scroller > .fc-time-grid {
  position: relative;
  /* re-scope all positions */
  width: 100%;
  /* hack to force re-sizing this inner element when scrollbars appear/disappear */
}

/* Global Event Styles
--------------------------------------------------------------------------------------------------*/
.fc-event {
  position: relative;
  /* for resize handle and other inner positioning */
  display: block;
  /* make the <a> tag block */
  font-size: 0.85em;
  line-height: 1.4;
  border-radius: 3px;
  border: 1px solid #3788d8;
}

.fc-event,
.fc-event-dot {
  background-color: #3788d8;
  /* default BACKGROUND color */
}

.fc-event,
.fc-event:hover {
  color: #fff;
  /* default TEXT color */
  text-decoration: none;
  /* if <a> has an href */
}

.fc-event[href],
.fc-event.fc-draggable {
  cursor: pointer;
  /* give events with links and draggable events a hand mouse pointer */
}

.fc-not-allowed,
.fc-not-allowed .fc-event {
  /* to override an event's custom cursor */
  cursor: not-allowed;
}

.fc-event .fc-content {
  position: relative;
  z-index: 2;
}

/* resizer (cursor AND touch devices) */
.fc-event .fc-resizer {
  position: absolute;
  z-index: 4;
}

/* resizer (touch devices) */
.fc-event .fc-resizer {
  display: none;
}

.fc-event.fc-allow-mouse-resize .fc-resizer,
.fc-event.fc-selected .fc-resizer {
  /* only show when hovering or selected (with touch) */
  display: block;
}

/* hit area */
.fc-event.fc-selected .fc-resizer:before {
  /* 40x40 touch area */
  content: "";
  position: absolute;
  z-index: 9999;
  /* user of this util can scope within a lower z-index */
  top: 50%;
  left: 50%;
  width: 40px;
  height: 40px;
  margin-left: -20px;
  margin-top: -20px;
}

/* Event Selection (only for touch devices)
--------------------------------------------------------------------------------------------------*/
.fc-event.fc-selected {
  z-index: 9999 !important;
  /* overcomes inline z-index */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.fc-event.fc-selected:after {
  content: "";
  position: absolute;
  z-index: 1;
  /* same z-index as fc-bg, behind text */
  /* overcome the borders */
  top: -1px;
  right: -1px;
  bottom: -1px;
  left: -1px;
  /* darkening effect */
  background: #000;
  opacity: 0.25;
}

/* Event Dragging
--------------------------------------------------------------------------------------------------*/
.fc-event.fc-dragging.fc-selected {
  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.3);
}

.fc-event.fc-dragging:not(.fc-selected) {
  opacity: 0.75;
}

/* Horizontal Events
--------------------------------------------------------------------------------------------------*/
/* bigger touch area when selected */
.fc-h-event.fc-selected:before {
  content: "";
  position: absolute;
  z-index: 3;
  /* below resizers */
  top: -10px;
  bottom: -10px;
  left: 0;
  right: 0;
}

/* events that are continuing to/from another week. kill rounded corners and butt up against edge */
.fc-ltr .fc-h-event.fc-not-start,
.fc-rtl .fc-h-event.fc-not-end {
  margin-left: 0;
  border-left-width: 0;
  padding-left: 1px;
  /* replace the border with padding */
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.fc-ltr .fc-h-event.fc-not-end,
.fc-rtl .fc-h-event.fc-not-start {
  margin-right: 0;
  border-right-width: 0;
  padding-right: 1px;
  /* replace the border with padding */
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

/* resizer (cursor AND touch devices) */
/* left resizer  */
.fc-ltr .fc-h-event .fc-start-resizer,
.fc-rtl .fc-h-event .fc-end-resizer {
  cursor: w-resize;
  left: -1px;
  /* overcome border */
}

/* right resizer */
.fc-ltr .fc-h-event .fc-end-resizer,
.fc-rtl .fc-h-event .fc-start-resizer {
  cursor: e-resize;
  right: -1px;
  /* overcome border */
}

/* resizer (mouse devices) */
.fc-h-event.fc-allow-mouse-resize .fc-resizer {
  width: 7px;
  top: -1px;
  /* overcome top border */
  bottom: -1px;
  /* overcome bottom border */
}

/* resizer (touch devices) */
.fc-h-event.fc-selected .fc-resizer {
  /* 8x8 little dot */
  border-radius: 4px;
  border-width: 1px;
  width: 6px;
  height: 6px;
  border-style: solid;
  border-color: inherit;
  background: #fff;
  /* vertically center */
  top: 50%;
  margin-top: -4px;
}

/* left resizer  */
.fc-ltr .fc-h-event.fc-selected .fc-start-resizer,
.fc-rtl .fc-h-event.fc-selected .fc-end-resizer {
  margin-left: -4px;
  /* centers the 8x8 dot on the left edge */
}

/* right resizer */
.fc-ltr .fc-h-event.fc-selected .fc-end-resizer,
.fc-rtl .fc-h-event.fc-selected .fc-start-resizer {
  margin-right: -4px;
  /* centers the 8x8 dot on the right edge */
}

/* DayGrid events
----------------------------------------------------------------------------------------------------
We use the full "fc-day-grid-event" class instead of using descendants because the event won't
be a descendant of the grid when it is being dragged.
*/
.fc-day-grid-event {
  margin: 1px 2px 0;
  /* spacing between events and edges */
  padding: 0 1px;
}

tr:first-child > td > .fc-day-grid-event {
  margin-top: 2px;
  /* a little bit more space before the first event */
}

.fc-mirror-skeleton tr:first-child > td > .fc-day-grid-event {
  margin-top: 0;
  /* except for mirror skeleton */
}

.fc-day-grid-event .fc-content {
  /* force events to be one-line tall */
  white-space: nowrap;
  overflow: hidden;
}

.fc-day-grid-event .fc-time {
  font-weight: bold;
}

/* resizer (cursor devices) */
/* left resizer  */
.fc-ltr .fc-day-grid-event.fc-allow-mouse-resize .fc-start-resizer,
.fc-rtl .fc-day-grid-event.fc-allow-mouse-resize .fc-end-resizer {
  margin-left: -2px;
  /* to the day cell's edge */
}

/* right resizer */
.fc-ltr .fc-day-grid-event.fc-allow-mouse-resize .fc-end-resizer,
.fc-rtl .fc-day-grid-event.fc-allow-mouse-resize .fc-start-resizer {
  margin-right: -2px;
  /* to the day cell's edge */
}

/* Event Limiting
--------------------------------------------------------------------------------------------------*/
/* "more" link that represents hidden events */
a.fc-more {
  margin: 1px 3px;
  font-size: 0.85em;
  cursor: pointer;
  text-decoration: none;
}

a.fc-more:hover {
  text-decoration: underline;
}

.fc-limited {
  /* rows and cells that are hidden because of a "more" link */
  display: none;
}

/* popover that appears when "more" link is clicked */
.fc-day-grid .fc-row {
  z-index: 1;
  /* make the "more" popover one higher than this */
}

.fc-more-popover {
  z-index: 2;
  width: 220px;
}

.fc-more-popover .fc-event-container {
  padding: 10px;
}

/* Now Indicator
--------------------------------------------------------------------------------------------------*/
.fc-now-indicator {
  position: absolute;
  border: 0 solid red;
}

/* Utilities
--------------------------------------------------------------------------------------------------*/
.fc-unselectable {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

/*
TODO: more distinction between this file and common.css
*/
/* Colors
--------------------------------------------------------------------------------------------------*/
.fc-unthemed th,
.fc-unthemed td,
.fc-unthemed thead,
.fc-unthemed tbody,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-row,
.fc-unthemed .fc-content,
.fc-unthemed .fc-popover,
.fc-unthemed .fc-list-view,
.fc-unthemed .fc-list-heading td {
  border-color: #ddd;
}

.fc-unthemed .fc-popover {
  background-color: #fff;
}

.fc-unthemed .fc-divider,
.fc-unthemed .fc-popover .fc-header,
.fc-unthemed .fc-list-heading td {
  background: #eee;
}

.fc-unthemed td.fc-today {
  background: #fcf8e3;
}

.fc-unthemed .fc-disabled-day {
  background: #d7d7d7;
  opacity: 0.3;
}

/* Icons
--------------------------------------------------------------------------------------------------
from https://feathericons.com/ and built with IcoMoon
*/
@font-face {
  font-family: "fcicons";
  src: url("data:application/x-font-ttf;charset=utf-8;base64,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") format("truetype");
  font-weight: normal;
  font-style: normal;
}
.fc-icon {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "fcicons" !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.fc-icon-chevron-left:before {
  content: "";
}

.fc-icon-chevron-right:before {
  content: "";
}

.fc-icon-chevrons-left:before {
  content: "";
}

.fc-icon-chevrons-right:before {
  content: "";
}

.fc-icon-minus-square:before {
  content: "";
}

.fc-icon-plus-square:before {
  content: "";
}

.fc-icon-x:before {
  content: "";
}

.fc-icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  text-align: center;
}

/* Buttons
--------------------------------------------------------------------------------------------------
Lots taken from Flatly (MIT): https://bootswatch.com/4/flatly/bootstrap.css
*/
/* reset */
.fc-button {
  border-radius: 0;
  overflow: visible;
  text-transform: none;
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

.fc-button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}

.fc-button {
  -webkit-appearance: button;
}

.fc-button:not(:disabled) {
  cursor: pointer;
}

.fc-button::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

/* theme */
.fc-button {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.4em 0.65em;
  font-size: 1em;
  line-height: 1.5;
  border-radius: 0.25em;
}

.fc-button:hover {
  color: #212529;
  text-decoration: none;
}

.fc-button:focus {
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(44, 62, 80, 0.25);
  box-shadow: 0 0 0 0.2rem rgba(44, 62, 80, 0.25);
}

.fc-button:disabled {
  opacity: 0.65;
}

/* "primary" coloring */
.fc-button-primary {
  color: #fff;
  background-color: #2C3E50;
  border-color: #2C3E50;
}

.fc-button-primary:hover {
  color: #fff;
  background-color: #1e2b37;
  border-color: #1a252f;
}

.fc-button-primary:focus {
  -webkit-box-shadow: 0 0 0 0.2rem rgba(76, 91, 106, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(76, 91, 106, 0.5);
}

.fc-button-primary:disabled {
  color: #fff;
  background-color: #2C3E50;
  border-color: #2C3E50;
}

.fc-button-primary:not(:disabled):active,
.fc-button-primary:not(:disabled).fc-button-active {
  color: #fff;
  background-color: #1a252f;
  border-color: #151e27;
}

.fc-button-primary:not(:disabled):active:focus,
.fc-button-primary:not(:disabled).fc-button-active:focus {
  -webkit-box-shadow: 0 0 0 0.2rem rgba(76, 91, 106, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(76, 91, 106, 0.5);
}

/* icons within buttons */
.fc-button .fc-icon {
  vertical-align: middle;
  font-size: 1.5em;
}

/* Buttons Groups
--------------------------------------------------------------------------------------------------*/
.fc-button-group {
  position: relative;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  vertical-align: middle;
}

.fc-button-group > .fc-button {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}

.fc-button-group > .fc-button:hover {
  z-index: 1;
}

.fc-button-group > .fc-button:focus,
.fc-button-group > .fc-button:active,
.fc-button-group > .fc-button.fc-button-active {
  z-index: 1;
}

.fc-button-group > .fc-button:not(:first-child) {
  margin-left: -1px;
}

.fc-button-group > .fc-button:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.fc-button-group > .fc-button:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

/* Popover
--------------------------------------------------------------------------------------------------*/
.fc-unthemed .fc-popover {
  border-width: 1px;
  border-style: solid;
}

/* List View
--------------------------------------------------------------------------------------------------*/
.fc-unthemed .fc-list-item:hover td {
  background-color: #f5f5f5;
}

/* Toolbar
--------------------------------------------------------------------------------------------------*/
.fc-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.fc-toolbar.fc-header-toolbar {
  margin-bottom: 0.5em;
}

.fc-toolbar.fc-footer-toolbar {
  margin-top: 1.5em;
}

/* inner content */
.fc-toolbar > * > :not(:first-child) {
  margin-left: 0.75em;
}

.fc-toolbar h2 {
  font-size: 1em;
  margin: 0;
}

/* View Structure
--------------------------------------------------------------------------------------------------*/
.fc-view-container {
  position: relative;
}

/* undo twitter bootstrap's box-sizing rules. normalizes positioning techniques */
/* don't do this for the toolbar because we'll want bootstrap to style those buttons as some pt */
.fc-view-container *,
.fc-view-container *:before,
.fc-view-container *:after {
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
}

.fc-view,
.fc-view > table {
  /* so dragged elements can be above the view's main element */
  position: relative;
  z-index: 1;
}

@media print {
  .fc {
    max-width: 100% !important;
  }

  /* Global Event Restyling
  --------------------------------------------------------------------------------------------------*/
  .fc-event {
    background: #fff !important;
    color: #000 !important;
    page-break-inside: avoid;
  }

  .fc-event .fc-resizer {
    display: none;
  }

  /* Table & Day-Row Restyling
  --------------------------------------------------------------------------------------------------*/
  .fc th,
.fc td,
.fc hr,
.fc thead,
.fc tbody,
.fc-row {
    border-color: #ccc !important;
    background: #fff !important;
  }

  /* kill the overlaid, absolutely-positioned components */
  /* common... */
  .fc-bg,
.fc-bgevent-skeleton,
.fc-highlight-skeleton,
.fc-mirror-skeleton,
.fc-bgevent-container,
.fc-business-container,
.fc-highlight-container,
.fc-mirror-container {
    display: none;
  }

  /* don't force a min-height on rows (for DayGrid) */
  .fc tbody .fc-row {
    height: auto !important;
    /* undo height that JS set in distributeHeight */
    min-height: 0 !important;
    /* undo the min-height from each view's specific stylesheet */
  }

  .fc tbody .fc-row .fc-content-skeleton {
    position: static;
    /* undo .fc-rigid */
    padding-bottom: 0 !important;
    /* use a more border-friendly method for this... */
  }

  .fc tbody .fc-row .fc-content-skeleton tbody tr:last-child td {
    /* only works in newer browsers */
    padding-bottom: 1em;
    /* ...gives space within the skeleton. also ensures min height in a way */
  }

  .fc tbody .fc-row .fc-content-skeleton table {
    /* provides a min-height for the row, but only effective for IE, which exaggerates this value,
       making it look more like 3em. for other browers, it will already be this tall */
    height: 1em;
  }

  /* Undo month-view event limiting. Display all events and hide the "more" links
  --------------------------------------------------------------------------------------------------*/
  .fc-more-cell,
.fc-more {
    display: none !important;
  }

  .fc tr.fc-limited {
    display: table-row !important;
  }

  .fc td.fc-limited {
    display: table-cell !important;
  }

  .fc-popover {
    display: none;
    /* never display the "more.." popover in print mode */
  }

  /* TimeGrid Restyling
  --------------------------------------------------------------------------------------------------*/
  /* undo the min-height 100% trick used to fill the container's height */
  .fc-time-grid {
    min-height: 0 !important;
  }

  /* don't display the side axis at all ("all-day" and time cells) */
  .fc-timeGrid-view .fc-axis {
    display: none;
  }

  /* don't display the horizontal lines */
  .fc-slats,
.fc-time-grid hr {
    /* this hr is used when height is underused and needs to be filled */
    display: none !important;
    /* important overrides inline declaration */
  }

  /* let the container that holds the events be naturally positioned and create real height */
  .fc-time-grid .fc-content-skeleton {
    position: static;
  }

  /* in case there are no events, we still want some height */
  .fc-time-grid .fc-content-skeleton table {
    height: 4em;
  }

  /* kill the horizontal spacing made by the event container. event margins will be done below */
  .fc-time-grid .fc-event-container {
    margin: 0 !important;
  }

  /* TimeGrid *Event* Restyling
  --------------------------------------------------------------------------------------------------*/
  /* naturally position events, vertically stacking them */
  .fc-time-grid .fc-event {
    position: static !important;
    margin: 3px 2px !important;
  }

  /* for events that continue to a future day, give the bottom border back */
  .fc-time-grid .fc-event.fc-not-end {
    border-bottom-width: 1px !important;
  }

  /* indicate the event continues via "..." text */
  .fc-time-grid .fc-event.fc-not-end:after {
    content: "...";
  }

  /* for events that are continuations from previous days, give the top border back */
  .fc-time-grid .fc-event.fc-not-start {
    border-top-width: 1px !important;
  }

  /* indicate the event is a continuation via "..." text */
  .fc-time-grid .fc-event.fc-not-start:before {
    content: "...";
  }

  /* time */
  /* undo a previous declaration and let the time text span to a second line */
  .fc-time-grid .fc-event .fc-time {
    white-space: normal !important;
  }

  /* hide the the time that is normally displayed... */
  .fc-time-grid .fc-event .fc-time span {
    display: none;
  }

  /* ...replace it with a more verbose version (includes AM/PM) stored in an html attribute */
  .fc-time-grid .fc-event .fc-time:after {
    content: attr(data-full);
  }

  /* Vertical Scroller & Containers
  --------------------------------------------------------------------------------------------------*/
  /* kill the scrollbars and allow natural height */
  .fc-scroller,
.fc-day-grid-container,
.fc-time-grid-container {
    /* */
    overflow: visible !important;
    height: auto !important;
  }

  /* kill the horizontal border/padding used to compensate for scrollbars */
  .fc-row {
    border: 0 !important;
    margin: 0 !important;
  }

  /* Button Controls
  --------------------------------------------------------------------------------------------------*/
  .fc-button-group,
.fc button {
    display: none;
    /* don't display any button-related controls */
  }
}

/* Divider between resources and time area
--------------------------------------------------------------------------------------------------*/
.fc-timeline .fc-divider {
  width: 3px;
  border-style: double;
  /* overcome neighboring borders */
}

.fc-timeline .fc-head > tr > .fc-divider {
  border-bottom: 0;
}

.fc-timeline .fc-body > tr > .fc-divider {
  border-top: 0;
}

/* Resource Area
--------------------------------------------------------------------------------------------------*/
.fc-resource-area {
  width: 30%;
}

.fc-resource-area col {
  width: 40%;
  min-width: 70px;
  /* will be read by JS */
}

.fc-resource-area col.fc-main-col {
  width: 60%;
  /* make the first column in a nested setup bigger */
}

.fc-flat .fc-expander-space {
  /* fc-flat is opposite of fc-nested */
  display: none;
}

.fc-ltr .fc-resource-area tr > * {
  text-align: left;
}

.fc-rtl .fc-resource-area tr > * {
  text-align: right;
}

.fc-resource-area .fc-cell-content {
  padding-left: 4px;
  padding-right: 4px;
}

/* head */
.fc-resource-area .fc-super th {
  text-align: center;
}

.fc-resource-area th > div {
  position: relative;
}

.fc-resource-area th .fc-cell-content {
  position: relative;
  z-index: 1;
}

.fc-resource-area th .fc-col-resizer {
  position: absolute;
  z-index: 2;
  top: 0;
  bottom: 0;
  width: 5px;
}

.fc-timeline .fc-col-resizer {
  cursor: col-resize;
}

.fc-ltr .fc-resource-area th .fc-col-resizer {
  right: -3px;
}

.fc-rtl .fc-resource-area th .fc-col-resizer {
  left: -3px;
}

/* body */
.fc-body .fc-resource-area .fc-cell-content {
  /* might BE the cell */
  padding-top: 8px;
  padding-bottom: 8px;
}

.fc-no-overlap .fc-body .fc-resource-area .fc-cell-content {
  /* might BE the cell */
  padding-top: 6px;
  padding-bottom: 6px;
}

.fc-resource-area .fc-icon {
  /* the expander and spacers before the expander */
  display: inline-block;
  width: 1em;
  /* ensure constant width, esp for empty icons */
  text-align: center;
  display: none;
}

.fc-resource-area .fc-expander {
  cursor: pointer;
  opacity: 0.65;
}

/* body resource rows */
.fc-time-area .fc-rows {
  position: relative;
  z-index: 3;
}

.fc-time-area .fc-rows td > div {
  position: relative;
}

.fc-time-area .fc-rows .fc-bgevent-container,
.fc-time-area .fc-rows .fc-highlight-container {
  z-index: 1;
}
/* DayGridView
--------------------------------------------------------------------------------------------------*/
/* day row structure */
.fc-dayGridWeek-view .fc-content-skeleton,
.fc-dayGridDay-view .fc-content-skeleton {
  /* there may be week numbers in these views, so no padding-top */
  padding-bottom: 1em;
  /* ensure a space at bottom of cell for user selecting/clicking */
}

.fc-dayGrid-view .fc-body .fc-row {
  min-height: 4em;
  /* ensure that all rows are at least this tall */
}

/* a "rigid" row will take up a constant amount of height because content-skeleton is absolute */
.fc-row.fc-rigid {
  overflow: hidden;
}

.fc-row.fc-rigid .fc-content-skeleton {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

/* week and day number styling */
.fc-day-top.fc-other-month {
  opacity: 0.3;
}

.fc-dayGrid-view .fc-week-number,
.fc-dayGrid-view .fc-day-number {
  padding: 2px;
}

.fc-dayGrid-view th.fc-week-number,
.fc-dayGrid-view th.fc-day-number {
  padding: 0 2px;
  /* column headers can't have as much v space */
}

.fc-ltr .fc-dayGrid-view .fc-day-top .fc-day-number {
  float: right;
}

.fc-rtl .fc-dayGrid-view .fc-day-top .fc-day-number {
  float: left;
}

.fc-ltr .fc-dayGrid-view .fc-day-top .fc-week-number {
  float: left;
  border-radius: 0 0 3px 0;
}

.fc-rtl .fc-dayGrid-view .fc-day-top .fc-week-number {
  float: right;
  border-radius: 0 0 0 3px;
}

.fc-dayGrid-view .fc-day-top .fc-week-number {
  min-width: 1.5em;
  text-align: center;
  background-color: #f2f2f2;
  color: #808080;
}

/* when week/day number have own column */
.fc-dayGrid-view td.fc-week-number {
  text-align: center;
}

.fc-dayGrid-view td.fc-week-number > * {
  /* work around the way we do column resizing and ensure a minimum width */
  display: inline-block;
  min-width: 1.25em;
}

/* TimeGridView all-day area
--------------------------------------------------------------------------------------------------*/
.fc-timeGrid-view .fc-day-grid {
  position: relative;
  z-index: 2;
  /* so the "more.." popover will be over the time grid */
}

.fc-timeGrid-view .fc-day-grid .fc-row {
  min-height: 3em;
  /* all-day section will never get shorter than this */
}

.fc-timeGrid-view .fc-day-grid .fc-row .fc-content-skeleton {
  padding-bottom: 1em;
  /* give space underneath events for clicking/selecting days */
}

/* TimeGrid axis running down the side (for both the all-day area and the slot area)
--------------------------------------------------------------------------------------------------*/
.fc .fc-axis {
  /* .fc to overcome default cell styles */
  vertical-align: middle;
  padding: 0 4px;
  white-space: nowrap;
}

.fc-ltr .fc-axis {
  text-align: right;
}

.fc-rtl .fc-axis {
  text-align: left;
}

/* TimeGrid Structure
--------------------------------------------------------------------------------------------------*/
.fc-time-grid-container,
.fc-time-grid {
  /* so slats/bg/content/etc positions get scoped within here */
  position: relative;
  z-index: 1;
}

.fc-time-grid {
  min-height: 100%;
  /* so if height setting is 'auto', .fc-bg stretches to fill height */
}

.fc-time-grid table {
  /* don't put outer borders on slats/bg/content/etc */
  border: 0 hidden transparent;
}

.fc-time-grid > .fc-bg {
  z-index: 1;
}

.fc-time-grid .fc-slats,
.fc-time-grid > hr {
  /* the <hr> TimeGridView injects when grid is shorter than scroller */
  position: relative;
  z-index: 2;
}

.fc-time-grid .fc-content-col {
  position: relative;
  /* because now-indicator lives directly inside */
}

.fc-time-grid .fc-content-skeleton {
  position: absolute;
  z-index: 3;
  top: 0;
  left: 0;
  right: 0;
}

/* divs within a cell within the fc-content-skeleton */
.fc-time-grid .fc-business-container {
  position: relative;
  z-index: 1;
}

.fc-time-grid .fc-bgevent-container {
  position: relative;
  z-index: 2;
}

.fc-time-grid .fc-highlight-container {
  position: relative;
  z-index: 3;
}

.fc-time-grid .fc-event-container {
  position: relative;
  z-index: 4;
}

.fc-time-grid .fc-now-indicator-line {
  z-index: 5;
}

.fc-time-grid .fc-mirror-container {
  /* also is fc-event-container */
  position: relative;
  z-index: 6;
}

/* TimeGrid Slats (lines that run horizontally)
--------------------------------------------------------------------------------------------------*/
.fc-time-grid .fc-slats td {
  height: 1.5em;
  border-bottom: 0;
  /* each cell is responsible for its top border */
}

.fc-time-grid .fc-slats .fc-minor td {
  border-top-style: dotted;
}

/* TimeGrid Highlighting Slots
--------------------------------------------------------------------------------------------------*/
.fc-time-grid .fc-highlight-container {
  /* a div within a cell within the fc-highlight-skeleton */
  position: relative;
  /* scopes the left/right of the fc-highlight to be in the column */
}

.fc-time-grid .fc-highlight {
  position: absolute;
  left: 0;
  right: 0;
  /* top and bottom will be in by JS */
}

/* TimeGrid Event Containment
--------------------------------------------------------------------------------------------------*/
.fc-ltr .fc-time-grid .fc-event-container {
  /* space on the sides of events for LTR (default) */
  margin: 0 2.5% 0 2px;
}

.fc-rtl .fc-time-grid .fc-event-container {
  /* space on the sides of events for RTL */
  margin: 0 2px 0 2.5%;
}

.fc-time-grid .fc-event,
.fc-time-grid .fc-bgevent {
  position: absolute;
  z-index: 1;
  /* scope inner z-index's */
}

.fc-time-grid .fc-bgevent {
  /* background events always span full width */
  left: 0;
  right: 0;
}

/* TimeGrid Event Styling
----------------------------------------------------------------------------------------------------
We use the full "fc-time-grid-event" class instead of using descendants because the event won't
be a descendant of the grid when it is being dragged.
*/
.fc-time-grid-event {
  margin-bottom: 1px;
}

.fc-time-grid-event-inset {
  -webkit-box-shadow: 0px 0px 0px 1px #fff;
  box-shadow: 0px 0px 0px 1px #fff;
}

.fc-time-grid-event.fc-not-start {
  /* events that are continuing from another day */
  /* replace space made by the top border with padding */
  border-top-width: 0;
  padding-top: 1px;
  /* remove top rounded corners */
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.fc-time-grid-event.fc-not-end {
  /* replace space made by the top border with padding */
  border-bottom-width: 0;
  padding-bottom: 1px;
  /* remove bottom rounded corners */
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.fc-time-grid-event .fc-content {
  overflow: hidden;
  max-height: 100%;
}

.fc-time-grid-event .fc-time,
.fc-time-grid-event .fc-title {
  padding: 0 1px;
}

.fc-time-grid-event .fc-time {
  font-size: 0.85em;
  white-space: nowrap;
}

/* short mode, where time and title are on the same line */
.fc-time-grid-event.fc-short .fc-content {
  /* don't wrap to second line (now that contents will be inline) */
  white-space: nowrap;
}

.fc-time-grid-event.fc-short .fc-time,
.fc-time-grid-event.fc-short .fc-title {
  /* put the time and title on the same line */
  display: inline-block;
  vertical-align: top;
}

.fc-time-grid-event.fc-short .fc-time span {
  display: none;
  /* don't display the full time text... */
}

.fc-time-grid-event.fc-short .fc-time:before {
  content: attr(data-start);
  /* ...instead, display only the start time */
}

.fc-time-grid-event.fc-short .fc-time:after {
  /* seperate with a dash, wrapped in nbsp's */
}

.fc-time-grid-event.fc-short .fc-title {
  font-size: 0.85em;
  /* make the title text the same size as the time */
  padding: 0;
  /* undo padding from above */
}

/* resizer (cursor device) */
.fc-time-grid-event.fc-allow-mouse-resize .fc-resizer {
  left: 0;
  right: 0;
  bottom: 0;
  height: 8px;
  overflow: hidden;
  line-height: 8px;
  font-size: 11px;
  font-family: monospace;
  text-align: center;
  cursor: s-resize;
}

.fc-time-grid-event.fc-allow-mouse-resize .fc-resizer:after {
  content: "=";
}

/* resizer (touch device) */
.fc-time-grid-event.fc-selected .fc-resizer {
  /* 10x10 dot */
  border-radius: 5px;
  border-width: 1px;
  width: 8px;
  height: 8px;
  border-style: solid;
  border-color: inherit;
  background: #fff;
  /* horizontally center */
  left: 50%;
  margin-left: -5px;
  /* center on the bottom edge */
  bottom: -5px;
}

/* Now Indicator
--------------------------------------------------------------------------------------------------*/
.fc-time-grid .fc-now-indicator-line {
  border-top-width: 1px;
  left: 0;
  right: 0;
}

/* arrow on axis */
.fc-time-grid .fc-now-indicator-arrow {
  margin-top: -5px;
  /* vertically center on top coordinate */
}

.fc-ltr .fc-time-grid .fc-now-indicator-arrow {
  left: 0;
  /* triangle pointing right... */
  border-width: 5px 0 5px 6px;
  border-top-color: transparent;
  border-bottom-color: transparent;
}

.fc-rtl .fc-time-grid .fc-now-indicator-arrow {
  right: 0;
  /* triangle pointing left... */
  border-width: 5px 6px 5px 0;
  border-top-color: transparent;
  border-bottom-color: transparent;
}

/* Scroller
--------------------------------------------------------------------------------------------------*/
.fc-scroller-clip {
  overflow: hidden;
  /* for clipping scrollbars */
  position: relative;
  /* so things like scrollfollowers can attach to this */
}

/* supresses rendering of native scrollbars */
/* on .fc-scroller */
.fc-no-scrollbars {
  background: rgba(255, 255, 255, 0);
  /* hack for dynamic DOM nodes (in Chrome OSX at least) */
}

.fc-no-scrollbars::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.fc-scroller-canvas {
  position: relative;
  /* origin for bg */
  box-sizing: border-box;
  /* so that padding (for gutter) will be part of height */
  min-height: 100%;
}

.fc-scroller-canvas > .fc-bg {
  z-index: 1;
  /* make default? */
}

.fc-scroller-canvas > .fc-content {
  z-index: 2;
  /* make default? */
  position: relative;
  /* origin for inner content */
  border-style: solid;
  border-width: 0;
}

.fc-scroller-canvas.fc-gutter-left > .fc-content {
  border-left-width: 1px;
  margin-left: -1px;
}

.fc-scroller-canvas.fc-gutter-right > .fc-content {
  border-right-width: 1px;
  margin-right: -1px;
}

.fc-scroller-canvas.fc-gutter-top > .fc-content {
  border-top-width: 1px;
  margin-top: -1px;
}

/* content is responsible for bottom border */
/* View Structure
--------------------------------------------------------------------------------------------------*/
.fc-rtl .fc-timeline {
  direction: rtl;
}

.fc-scrolled .fc-head .fc-scroller {
  z-index: 2;
  /* so drop shadow will go above body panes */
}

.fc-timeline.fc-scrolled .fc-head .fc-scroller {
  box-shadow: 0 3px 4px rgba(0, 0, 0, 0.075);
}

.fc-timeline .fc-body .fc-scroller {
  z-index: 1;
}

/*
on most tables that expand to the edges, kill the outer border,
because the container elements take care of it.
example tables:
.fc-scroller-canvas .fc-content table
.fc-scroller-canvas .fc-bg .fc-slats table
*/
.fc-timeline .fc-scroller-canvas > div > table,
.fc-timeline .fc-scroller-canvas > div > div > table {
  border-style: hidden;
}

/*
for resource rows (in both the spreadsheet and timeline areas),
undo previous rule in order to always show last border.
*/
.fc-timeline .fc-scroller-canvas > .fc-content > .fc-rows > table {
  border-bottom-style: none;
}

/* Table Cell Common
--------------------------------------------------------------------------------------------------*/
.fc-timeline th,
.fc-timeline td {
  white-space: nowrap;
}

.fc-timeline .fc-body td {
  padding-top: 10px;
  padding-bottom: 10px;
}

td.fc-resource-area.fc-widget-content,
td.fc-time-area.fc-widget-content
{
  padding: 0;
}

.fc-timeline .fc-cell-content {
  overflow: hidden;
}

.fc-timeline .fc-cell-text {
  display: inline-block;
  padding-left: 4px;
  padding-right: 4px;
}

/*
Cells at the start of a week
TODO: figure out better styling

.fc-ltr .fc-timeline .fc-em-cell div {
  border-left: 3px solid #eee;
  height: 100%;
}
.fc-rtl .fc-timeline .fc-em-cell {
  border-right-width: 3px;
}
*/
/* head */
.fc-timeline th {
  vertical-align: middle;
}

.fc-timeline .fc-head .fc-cell-content {
  padding-top: 3px;
  padding-bottom: 3px;
}

.fc-timeline .fc-head .fc-time-area .fc-cell-content {
  overflow: visible;
}

/* Time Area
--------------------------------------------------------------------------------------------------*/
.fc-time-area col {
  min-width: 2.2em;
  /* detected by JS */
}

/* head */
.fc-ltr .fc-time-area .fc-chrono th {
  text-align: left;
}

.fc-rtl .fc-time-area .fc-chrono th {
  text-align: right;
}

/* body slats (vertical lines) */
.fc-time-area .fc-slats {
  /* fc-bg is responsible for a lot of this now! */
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.fc-time-area .fc-slats table {
  height: 100%;
}

.fc-time-area .fc-slats .fc-minor {
  border-style: dotted;
}

.fc-time-area .fc-slats td {
  border-width: 0 1px;
  /* need to do this. sometimes -1 margin wouldn't hide the dotted */
}

.fc-ltr .fc-time-area .fc-slats td {
  border-right-width: 0;
}

.fc-rtl .fc-time-area .fc-slats td {
  border-left-width: 0;
}

/* body content containers
   can be within rows or directly within the pane's content
*/
.fc-time-area .fc-bgevent-container,
.fc-time-area .fc-highlight-container {
  position: absolute;
  z-index: 2;
  /* only for directly within pane. not for row. overridden later */
  top: 0;
  bottom: 0;
  width: 0;
}

.fc-ltr .fc-time-area .fc-mirror-container,
.fc-ltr .fc-time-area .fc-bgevent-container,
.fc-ltr .fc-time-area .fc-highlight-container {
  left: 0;
}

.fc-rtl .fc-time-area .fc-mirror-container,
.fc-rtl .fc-time-area .fc-bgevent-container,
.fc-rtl .fc-time-area .fc-highlight-container {
  right: 0;
}

.fc-time-area .fc-bgevent,
.fc-time-area .fc-highlight {
  position: absolute;
  top: 0;
  bottom: 0;
}

/* Now Indicator
--------------------------------------------------------------------------------------------------*/
.fc-timeline .fc-now-indicator {
  /* both the arrow and the line */
  z-index: 3;
  /* one above scroller's fc-content */
  top: 0;
}

.fc-time-area .fc-now-indicator-arrow {
  margin: 0 -6px;
  /* 5, then one more to counteract scroller's negative margins */
  /* triangle pointing down... */
  border-width: 6px 5px 0 5px;
  border-left-color: transparent;
  border-right-color: transparent;
}

.fc-time-area .fc-now-indicator-line {
  margin: 0 -1px;
  /* counteract scroller's negative margins */
  bottom: 0;
  border-left-width: 1px;
}

/* Event Container
--------------------------------------------------------------------------------------------------*/
.fc-time-area .fc-event-container {
  position: relative;
  z-index: 2;
  /* above bgevent and highlight */
  width: 0;
  /* for event positioning. will end up on correct side based on dir */
}

.fc-time-area .fc-mirror-container {
  /* also an fc-event-container */
  position: absolute;
  z-index: 3;
  top: 0;
}

.fc-time-area .fc-event-container {
  padding-bottom: 8px;
  top: -1px;
}

.fc-time-area tr:first-child .fc-event-container {
  top: 0;
}

.fc-no-overlap .fc-time-area .fc-event-container {
  padding-bottom: 0;
  top: 0;
}

/* Time Grid Events
--------------------------------------------------------------------------------------------------*/
.fc-timeline-event {
  position: absolute;
  display: flex;
  border-radius: 0;
  padding: 2px 1px;
  margin-bottom: 1px;
}

.fc-no-overlap .fc-timeline-event {
  padding-top: 5px;
  padding-bottom: 5px;
  margin-bottom: 0;
}

.fc-ltr .fc-timeline-event {
  flex-direction: row;
  margin-right: 1px;
}

.fc-rtl .fc-timeline-event {
  margin-left: 1px;
}

.fc-timeline-event .fc-time-wrap {
  flex-shrink: 0;
  min-width: 0;
}

.fc-timeline-event .fc-title-wrap {
  flex-grow: 1;
  min-width: 0;
}

.fc-timeline-event .fc-time,
.fc-timeline-event .fc-title {
  display: inline-block;
  vertical-align: top;
  max-width: 100%;
  padding: 0 2px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  font-size: 14px;
}

.fc-timeline-event .fc-time {
  font-weight: bold;
}

.fc-timeline-event.fc-not-start:before,
.fc-timeline-event.fc-not-end:after {
  content: "";
  align-self: center;
  width: 0;
  height: 0;
  margin: 0 1px;
  border: 5px solid #000;
  border-top-color: transparent;
  border-bottom-color: transparent;
  opacity: 0.5;
}

.fc-ltr .fc-timeline-event.fc-not-start:before,
.fc-rtl .fc-timeline-event.fc-not-end:after {
  border-left: 0;
}

.fc-ltr .fc-timeline-event.fc-not-end:after,
.fc-rtl .fc-timeline-event.fc-not-start:before {
  border-right: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Planning/Planning.vue